<script lang="ts">
    import { ReminderMemoryManagerSettings } from "@utils/practice/reminder-memory-manager"
    import {
        PerDayLessonGenerator,
        type LessonTime,
        PerHourLessonGenerator,
        isGenerator,
        isLessonTime,
    } from "@utils/practice/reminder-time-conversion"
    import TimeSliderWrapper from "./time-slider-wrapper.svelte"
    import { Channel } from "@utils/cap-notification-manager/cap-notification-manager"
    import type { MinutesAfterMidnight } from "@utils/practice/day-time"

    type Task =
        | LessonTime
        | PerDayLessonGenerator
        | PerHourLessonGenerator
        | "Temptation"
        | null
        | undefined

    /**
     * If the notifications are set we don't want it to be editable
     */
    export let notificationsSet: boolean
    export let wakeup: MinutesAfterMidnight
    export let sleep: MinutesAfterMidnight

    export let bufferedWake: MinutesAfterMidnight
    export let bufferedSleep: MinutesAfterMidnight

    export let reactiveMemoryManager: ReminderMemoryManagerSettings

    export let main: Task
    export let hourly: Task
    export let freq: Task
    export let temptation: boolean
    export let mainAllowed: boolean
    export let hourlyAllowed: boolean
    export let freqAllowed: boolean

    $: mainTime = isGenerator(main)
        ? main.generateFromOption(reactiveMemoryManager.getGeneration(main))
        : isLessonTime(main)
          ? (main as LessonTime)
          : null
    $: hourlyTime = isGenerator(hourly)
        ? hourly.generateFromOption(reactiveMemoryManager.getGeneration(hourly))
        : isLessonTime(hourly)
          ? (hourly as LessonTime)
          : null
    $: frequentTime = isGenerator(freq)
        ? freq.generateFromOption(reactiveMemoryManager.getGeneration(freq))
        : isLessonTime(freq)
          ? (freq as LessonTime)
          : null

    $: practiceTimes = [
        ...(frequentTime
            ? ([
                  [
                      frequentTime,
                      reactiveMemoryManager.channelIsEnabled(Channel.FREQUENT_REMINDERS),
                      "bg-purple-400 opacity-30",
                      freqAllowed,
                  ],
              ] as const)
            : []),
        ...(hourlyTime
            ? ([
                  [
                      hourlyTime,
                      reactiveMemoryManager.channelIsEnabled(Channel.HOURLY_REMEMBRANCE),
                      "bg-red-400",
                      hourlyAllowed,
                  ],
              ] as const)
            : []),
        ...(mainTime
            ? ([
                  [
                      mainTime,
                      reactiveMemoryManager.channelIsEnabled(Channel.MAIN_PRACTICE),
                      "bg-orange-400",
                      mainAllowed,
                  ],
              ] as const)
            : []),
    ]
</script>

<TimeSliderWrapper
    {notificationsSet}
    {bufferedSleep}
    {bufferedWake}
    {mainAllowed}
    {hourlyAllowed}
    {freqAllowed}
    {reactiveMemoryManager}
    {temptation}
    temptationEnabled={reactiveMemoryManager.channelIsEnabled(Channel.TEMPTATION)}
    {wakeup}
    {sleep}
    practiceTimes={[...practiceTimes]}
/>
